export enum EnumEstadoEquipo {
    Activo = 1,
    Suspendido = 2,
    SinContrato = 3,
    MantenimientoACosto = 4,
    EquipoEnReparacion = 5,
    EquipoEnMora = 6
}